import React from 'react';
import { Theme } from '@emotion/react';
import { SxProps } from '@mui/material';

import { IndeterminateValue, isIndeterminate, PropertySelectField } from '@paragon/client-tools';
import { naturalSortByProperty } from '@paragon/utilities';

import {
  getAllFeaturePatternContainersDictionary,
  getVisibleFeaturePatternContainersDictionary,
} from '../../store/selectors/layoutDataSelectors';
import { useAppSelector } from '../hooks';

interface Props {
  sx?: SxProps<Theme>;
  disabled?: boolean;

  featurePatternContainerGuid: string | null | IndeterminateValue;
  onChange: (featurePatternContainerGuid: string) => void;

  levelGuidFilter?: string | null | IndeterminateValue;
}

export function FeaturePatternContainerSelect({
  sx,
  disabled,
  featurePatternContainerGuid,
  onChange,
  levelGuidFilter,
}: Props) {
  const allFeaturePatternContainers = useAppSelector(getAllFeaturePatternContainersDictionary);
  const featurePatternContainers = useAppSelector(getVisibleFeaturePatternContainersDictionary);

  return (
    <PropertySelectField<string>
      sx={sx}
      margin="normal"
      property="Feature Pattern Container"
      disabled={disabled || isIndeterminate(levelGuidFilter)}
      allowUnknownValues={isIndeterminate(featurePatternContainerGuid)}
      value={featurePatternContainerGuid}
      getValue={(featurePatternContainerGuid) => featurePatternContainerGuid}
      getName={(featurePatternContainerGuid) => allFeaturePatternContainers[featurePatternContainerGuid].name}
      options={naturalSortByProperty(
        Object.values(featurePatternContainers).filter(
          (container) => levelGuidFilter === undefined || container.levelGuid === levelGuidFilter,
        ),
        (container) => container.name,
      ).map((container) => container.guid)}
      submit={onChange}
    />
  );
}
